export const deleteFileFromQuestion = (payload?: any) => ({
    type: "@saga/DELETE_FILE_FROM_QUESTION",
    payload
});

